'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _toConsumableArray = _interopDefault(require('babel-runtime/helpers/toConsumableArray'));
var $ = _interopDefault(require('jquery'));

var $body = $(document.body);
var formSelector = '.marketing-form';
var floatingSelector = '.marketing-input--floating';
var inputWrapperSelector = '.marketing-input-wrapper';

function toggleFloatingLabels(evt) {
  var $element = $(evt.currentTarget);
  var val = $element.val();
  var $inputWrapper = $element.closest(inputWrapperSelector);

  if (!$inputWrapper.length && evt.type !== 'force-reset') {
    return;
  }

  if (val.length > 0 && evt.type !== 'force-reset') {
    $inputWrapper.addClass('js-is-filled');
  } else {
    $inputWrapper.removeClass('js-is-filled');
  }
}

$body.on('change keyup blur force-reset', floatingSelector, toggleFloatingLabels);

// if the page loads with pre-filled inputs the label should be visible
var nodes = [].concat(_toConsumableArray(document.querySelectorAll(floatingSelector)));
nodes.forEach(function (node) {
  return toggleFloatingLabels({ currentTarget: node });
});

// force-reset event is required due to the clearing of the input (when val.length === 0)
// occuring after the toggleFloatingLabels function has run
$(formSelector).on('reset', function (evt) {
  $(evt.currentTarget).find(floatingSelector).trigger('force-reset');
});

// eslint-disable-next-line import/no-anonymous-default-export
var forms = {
  toggleFloatingLabels: toggleFloatingLabels
};

module.exports = forms;
